/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApprovedAccessOrderByPaginationQuery } from './ApprovedAccessOrderByPaginationQuery';
import {
    ApprovedAccessOrderByPaginationQueryFromJSON,
    ApprovedAccessOrderByPaginationQueryFromJSONTyped,
    ApprovedAccessOrderByPaginationQueryToJSON,
    ApprovedAccessOrderByPaginationQueryToJSONTyped,
} from './ApprovedAccessOrderByPaginationQuery';
import type { ApplicationFilterRequest } from './ApplicationFilterRequest';
import {
    ApplicationFilterRequestFromJSON,
    ApplicationFilterRequestFromJSONTyped,
    ApplicationFilterRequestToJSON,
    ApplicationFilterRequestToJSONTyped,
} from './ApplicationFilterRequest';

/**
 * 
 * @export
 * @interface ApprovedAccessSearchRequest
 */
export interface ApprovedAccessSearchRequest {
    /**
     * 
     * @type {ApprovedAccessOrderByPaginationQuery}
     * @memberof ApprovedAccessSearchRequest
     */
    paginationQuery?: ApprovedAccessOrderByPaginationQuery;
    /**
     * 
     * @type {ApplicationFilterRequest}
     * @memberof ApprovedAccessSearchRequest
     */
    applicationFilter?: ApplicationFilterRequest;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAccessSearchRequest
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAccessSearchRequest
     */
    surname?: string | null;
    /**
     * 
     * @type {Array<any>}
     * @memberof ApprovedAccessSearchRequest
     */
    roleIds?: Array<any> | null;
    /**
     * 
     * @type {Array<any>}
     * @memberof ApprovedAccessSearchRequest
     */
    permissionIds?: Array<any> | null;
}

/**
 * Check if a given object implements the ApprovedAccessSearchRequest interface.
 */
export function instanceOfApprovedAccessSearchRequest(value: object): value is ApprovedAccessSearchRequest {
    return true;
}

export function ApprovedAccessSearchRequestFromJSON(json: any): ApprovedAccessSearchRequest {
    return ApprovedAccessSearchRequestFromJSONTyped(json, false);
}

export function ApprovedAccessSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApprovedAccessSearchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationQuery': json['paginationQuery'] == null ? undefined : ApprovedAccessOrderByPaginationQueryFromJSON(json['paginationQuery']),
        'applicationFilter': json['applicationFilter'] == null ? undefined : ApplicationFilterRequestFromJSON(json['applicationFilter']),
        'firstName': json['firstName'] === undefined ? undefined : json['firstName'] === null ? null : json['firstName'],
        'surname': json['surname'] === undefined ? undefined : json['surname'] === null ? null : json['surname'],
        'roleIds': json['roleIds'] === undefined ? undefined : json['roleIds'] === null ? null : json['roleIds'],
        'permissionIds': json['permissionIds'] === undefined ? undefined : json['permissionIds'] === null ? null : json['permissionIds'],
    };
}

export function ApprovedAccessSearchRequestToJSON(json: any): ApprovedAccessSearchRequest {
    return ApprovedAccessSearchRequestToJSONTyped(json, false);
}

export function ApprovedAccessSearchRequestToJSONTyped(value?: ApprovedAccessSearchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationQuery': ApprovedAccessOrderByPaginationQueryToJSON(value['paginationQuery']),
        'applicationFilter': ApplicationFilterRequestToJSON(value['applicationFilter']),
        'firstName': value['firstName'],
        'surname': value['surname'],
        'roleIds': value['roleIds'],
        'permissionIds': value['permissionIds'],
    };
}

